import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const Blogs = () => {
 const blogs = [
  {
    title:
      "IIT-Patna scholars developing virtual doctor for early diagnosis of diseases",
    description:
      "In a novel and path-breaking initiative, IIT Patna is busy developing a virtual doctor to assist medical practitioners and facilitate early diagnosis of diseases. The virtual doctor will serve as a disease diagnostic assistant, conducting symptom investigations and preparing diagnostic reports for doctors.",
    image: "../img/news1.jpeg",
    category: "Healthcare AI",
    language: "English",
    link: "https://timesofindia.indiatimes.com/city/patna/iit-patna-scholars-developing-virtual-doctor-for-early-diagnosis-of-diseases/articleshow/94141545.cms",
  },

  {
    title:
      "IIT पटना बना रहा वर्चुअल डॉक्टर, एप की मदद से होगा इलाज, जानें क्या होगा खास",
    description:
      "अब जल्द ही मरीजों के इलाज में वर्चुअल डॉक्टर भी अहम भूमिका निभायेंगे। यह AI आधारित एंड्रॉयड एप मरीजों की बीमारी का शुरुआती विश्लेषण करेगा और डॉक्टरों को रिपोर्ट प्रदान करेगा।",
    image: "../img/news2.jpeg",
    category: "AI Innovation",
    language: "Hindi",
    link: "https://www.prabhatkhabar.com/state/bihar/patna/iit-patna-is-making-virtual-doctor-for-telemedicine-facility-will-be-easy-ans",
  },

  {
    title:
      "Inter IIT Tech Meet 12.0 Bronze Medal Achievement",
    description:
      "The Clinical AI Assistance team secured a bronze medal at Inter IIT Tech Meet 12.0 among 20 IITs. IIT Patna achieved an outstanding score of 133 and ranked among the top teams.",
    image: "../img/CDAC Meeting.svg",
    category: "Achievement",
    language: "English",
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7147284787328606208",
  },

  {
    title:
      "Abhisek Tiwari Unveils Groundbreaking Clinical AI Assistant Dr. Aayush",
    description:
      "In an exclusive interview, Abhisek Tiwari discussed Dr. Aayush, a clinical AI assistant designed to enhance hospital efficiency by conducting initial disease diagnostics and preparing reports for doctors.",
    image: "../img/aayush.png",
    category: "Clinical AI",
    language: "English",
    link: "https://theinterview.world/dr-aayush-accelerates-the-rise-of-clinical-ai-assistance/",
  },

  {
    title:
      "Sriparna Saha Mentions Dr. Aayush in AI Empowerment Talk",
    description:
      "Sriparna Saha, one of India's leading women scientists in AI and Associate Editor of IEEE, highlighted Dr. Aayush in her talk, recognizing it as a remarkable innovation in healthcare AI.",
    image: "https://img.youtube.com/vi/BfPw-NfddPI/maxresdefault.jpg", // add image if available
    category: "Women in AI",
    language: "English",
    link: "https://www.youtube.com/watch?v=BfPw-NfddPI&t=574s",
  },

  {
    title:
      "IIT के अभिषेक तिवारी ने बनाया वर्चुअल डॉक्टर 'डॉ. आयुष'",
    description:
      "पटना IIT के शोध छात्र अभिषेक तिवारी ने AI आधारित सॉफ्टवेयर 'डॉ. आयुष' विकसित किया है, जो मरीजों की शुरुआती बीमारी का विश्लेषण कर डॉक्टरों को सहायता प्रदान करेगा.",
    image: "https://img.youtube.com/vi/tL9dY7ONsH4/hqdefault.jpg", // add image if available
    category: "Medical Technology",
    language: "Hindi",
    link: "https://www.youtube.com/watch?v=tL9dY7ONsH4",
  },
];

  return (
    <section className="bg-gray-50 dark:bg-black py-20 px-4 sm:px-6 lg:px-10">
      {/* Heading */}
      <div className="text-center max-w-4xl mx-auto">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-4xl md:text-6xl font-bold text-black dark:text-white"
        >
          Latest News & Blogs
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="mt-5 text-lg text-gray-600 dark:text-gray-400"
        >
          Explore the latest achievements, innovations, and media coverage
          around Clinical AI Assistance and Dr. Pre-Consultant.
        </motion.p>
      </div>

      {/* Blog Grid */}
      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
        {blogs.map((blog, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            whileHover={{ y: -10 }}
            className="bg-white dark:bg-[#111] rounded-3xl overflow-hidden shadow-lg border border-gray-200 dark:border-gray-800"
          >
            {/* Image */}
            <div className="h-60 overflow-hidden">
              <img
                src={blog.image}
                alt={blog.title}
                className="w-full h-full object-cover hover:scale-105 transition duration-500"
              />
            </div>

            {/* Content */}
            <div className="p-6">
              {/* Category */}
              <div className="flex items-center justify-between">
                <span
                  className="bg-[#106EE8]/10 text-[#106EE8] 
                  text-xs font-semibold px-3 py-1 rounded-full"
                >
                  {blog.category}
                </span>

                <span className="text-xs text-gray-500">
                  {blog.language}
                </span>
              </div>

              {/* Title */}
              <h2
                className="mt-5 text-xl font-bold text-black 
                dark:text-white line-clamp-2"
              >
                {blog.title}
              </h2>

              {/* Description */}
              <p
                className="mt-4 text-gray-600 dark:text-gray-400 
                text-sm leading-relaxed line-clamp-4"
              >
                {blog.description}
              </p>

              {/* Read More */}
              <a
  href={blog.link}
  target="_blank"
  rel="noopener noreferrer"
  className="mt-6 inline-flex items-center gap-2 text-[#106EE8] font-semibold hover:gap-3 transition-all"
>
  Read More
  <ArrowRight size={18} />
</a>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Blogs;